/* global google */
import React, { useEffect, useRef, useState } from "react";

/* --------------------------------------------------------------
   Props (plain JS – no types)
   -------------------------------------------------------------- */
export const GooglePlacesInput = ({
  onPlaceSelect,   // (place) => void   place = {address, placeId, lat, lng}
  value = "",      // always a string
  placeholder = "Enter address…",
  className = "",
}) => {
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const autocompleteRef = useRef(null);

  const [internalValue, setInternalValue] = useState(String(value || ""));
  const [scriptReady, setScriptReady] = useState(false);
  const [useLegacy, setUseLegacy] = useState(false);

  /* --------------------------------------------------------
     1. Load Google script once (beta = newest web components)
     -------------------------------------------------------- */
  useEffect(() => {
    if (!process.env.REACT_APP_GOOGLE_PLACES_API_KEY) {
      console.error("REACT_APP_GOOGLE_PLACES_API_KEY missing in .env");
      return;
    }

    const url = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACES_API_KEY}&v=beta&libraries=places`;

    // Already loaded?
    if (window.google?.maps?.places?.PlaceAutocompleteElement) {
      setScriptReady(true);
      return;
    }

    const existing = document.querySelector(`script[src*="${process.env.REACT_APP_GOOGLE_PLACES_API_KEY}"]`);
    if (existing) {
      const onLoad = () => setScriptReady(true);
      existing.addEventListener("load", onLoad);
      return () => existing.removeEventListener("load", onLoad);
    }

    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    script.onload = () => setScriptReady(true);
    script.onerror = () => console.error("Failed to load Google Maps script");
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) document.head.removeChild(script);
    };
  }, []);

  /* --------------------------------------------------------
     2. Sync external value (prevents uncontrolled warning)
     -------------------------------------------------------- */
  useEffect(() => {
    setInternalValue(String(value || ""));
  }, [value]);

  /* -------------------------------------------------------

  
  /* --------------------------------------------------------
     4. Manual typing
     -------------------------------------------------------- */
  const handleChange = (e) => {
    const v = e.target.value;
    setInternalValue(v);
    if (v.length < 3) {
      console.warn("Input too short – no API call (prevents 400)");
    }
    onPlaceSelect({
      address: v,
      placeId: "",
      lat: 0,
      lng: 0,
    });
  };

  /* --------------------------------------------------------
     Render
     -------------------------------------------------------- */
  return (
    // <div ref={containerRef} style={{ position: "relative" }}>
      <input
        ref={inputRef}
        type="text"
        placeholder={scriptReady ? placeholder : "Loading Google Places…"}
        value={internalValue}
        onChange={handleChange}
        className={`tutor-input-field ${className}`}
        autoComplete="off"
        disabled={!scriptReady}
      />
    //  </div>
  );
};

export default GooglePlacesInput;